import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import * as Sentry from '@sentry/angular';
import { PanelDetailGeofencesService } from '../../../../services/Panel-Detail-Geofences.service';
import { GeofencesService } from '../../../../services/Geofences.service';
import { PanelAddGeofencesService } from '../../../../services/Panel-Add-Geofences.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { trigger, state, style, transition, animate } from "@angular/animations";
import { TutorialService } from 'src/app/features/ui/organisms/tutorial/services/tutorial.service';
import { PanelInternalLayerService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Internal-Layer.service';
import { environment } from "src/environments/environment";

@Component({
  selector: 'panel-detail-geofences',
  templateUrl: './panel-detail-geofences.component.html',
  styleUrls: ['./panel-detail-geofences.component.css'],
  animations: [
    trigger("mostrarHerramientas", [
      state("visible", style({ opacity: 1, height: "*", minHeight: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", minHeight: "0", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("200ms ease-in-out")),
    ]),
  ],
})
export class PanelDetailGeofencesComponent implements OnInit, OnDestroy {
  Guid: string;
  Title: string;
  Subtitle: string;
  Keys: string[];
  Values: string[];
  identifiers: string[] = [];
  LastUpdate: string;
  isVisibleDetails: boolean;
  private $Guid: Observable<string> = new Observable<string>();
  private $Title: Observable<string> = new Observable<string>();
  private $Subtitle: Observable<string> = new Observable<string>();
  private $Keys: Observable<string[]> = new Observable<string[]>();
  private $Values: Observable<string[]> = new Observable<string[]>();
  private $LastUpdate: Observable<string> = new Observable<string>();
  public isLoading: boolean = false;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  $isVisibleDetails: Observable<boolean> = new Observable<boolean>();
  isMapix: boolean = false;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  fullScreen: boolean = false;

  // Variable para controlar la visibilidad del botón de herramientas
  isToolButtonPressed: boolean = false;

  subscription_delete: Subscription;
  subscription_Guid: Subscription;
  subscription_Title: Subscription;
  subscription_Subtitle: Subscription;
  subscription_Keys: Subscription;
  subscription_Values: Subscription;
  subscription_LastUpdate: Subscription;
  subscription_isVisibleDetails: Subscription;
  subscription_isLoading: Subscription;

  constructor(private panelGeofenceDetailService : PanelDetailGeofencesService, 
    private geofenceService : GeofencesService,
    private sessionService: SessionService,
    private notifyService: SwalNotificationService,
    private panelAddGeofenceService: PanelAddGeofencesService,
    private tutorialService: TutorialService,
    private panelInternalLayerService: PanelInternalLayerService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
    ) {
      this.mobileQuery = media.matchMedia("(min-width: 769px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);

      this.$Guid = this.panelGeofenceDetailService.getGuid();
      this.subscription_Guid = this.$Guid.subscribe((element) => {
        this.Guid = "";
        this.Guid = element;
      });
    this.$Title = this.panelGeofenceDetailService.getTitle();
    this.subscription_Title = this.$Title.subscribe((element) => {
      this.Title = "";
      this.Title = element;
    });
    this.$Subtitle = this.panelGeofenceDetailService.getSubtitle();
    this.subscription_Subtitle = this.$Subtitle.subscribe((element) => {
      this.Subtitle = "";
      this.Subtitle = element;
    });
    this.$LastUpdate = this.panelGeofenceDetailService.getLastUpdate();
    this.subscription_LastUpdate = this.$LastUpdate.subscribe((element) => {
      this.LastUpdate = "";
      this.LastUpdate = element;
    });
    this.$Keys = this.panelGeofenceDetailService.getKeys();
    this.subscription_Keys = this.$Keys.subscribe((element) => {
      this.Keys = [];
      this.Keys = element;
      if (this.identifiers.length == 0) {
        const identifiersValue = this.Values[this.Keys.indexOf("Identifiers")];
        this.identifiers = identifiersValue ? identifiersValue.split(",").filter((id: string) => id !== "" && id !== 'Sin Registros') : [];
      }
    });
    this.$Values = this.panelGeofenceDetailService.getValues();
    this.subscription_Values = this.$Values.subscribe((element) => {
      this.Values = [];
      this.Values = element;
    });
    this.$isVisibleDetails = this.panelGeofenceDetailService.checkVisibilityPopup();
    this.subscription_isVisibleDetails = this.$isVisibleDetails.subscribe((element) => {
      this.isVisibleDetails = element;
    });
    this.subscription_isLoading =this.panelGeofenceDetailService.getLoading().subscribe((data: boolean) =>{
      this.isLoading = data;
    });


  }

  ngOnInit(): void {
    this.checkingURL();
    this.panelGeofenceDetailService.setLoading(true);
  }

  ngOnDestroy(): void {
    if (this.subscription_delete)
      this.subscription_delete.unsubscribe();
    if (this.subscription_Guid)
      this.subscription_Guid.unsubscribe();
    if (this.subscription_Title)
      this.subscription_Title.unsubscribe();
    if (this.subscription_Subtitle)
      this.subscription_Subtitle.unsubscribe();
    if (this.subscription_Keys)
      this.subscription_Keys.unsubscribe();
    if (this.subscription_Values)
      this.subscription_Values.unsubscribe();
    if (this.subscription_LastUpdate)
      this.subscription_LastUpdate.unsubscribe();
    if (this.subscription_isVisibleDetails)
      this.subscription_isVisibleDetails.unsubscribe();
    if (this.subscription_isLoading)
      this.subscription_isLoading.unsubscribe();
  }
 
  // onClickItem(e){
  //   this.panelDetalilService.setVisibilityPopup(true);
  //   this.panelDetalilService.setInformation(e.features[0].properties, e.features[0].properties._Id,e.features[0].properties._CreatedIn);

  //         this.panelDetalilService.setData(e.features[0].properties);
  //         this.panelDetalilService.setTitle(e.features[0].properties._Id);
  //         this.panelDetalilService.setLastUpdate(
  //           e.features[0].properties._CreatedIn
  //         );
  // }

  onEdit(){
    this.panelAddGeofenceService.$guidEditable = this.Guid;
    this.geofenceService.setVisiblePanelGeofences(false);
    this.geofenceService.setVisiblePanelDetailGeofences(false);
    //selecciona el componnte de edicion
    this.geofenceService.setVisiblePanelEditGeofences(true);
  }

  onDelete(){
    var resp = this.notifyService.confirmMessage("Borrado","¿Seguro que desea borrar la geocerca "+this.Title+"?");
    resp.then((result) =>{
       if(result.value)
       {
          // window.open(urlb,'_blank');
          this.subscription_delete = this.geofenceService.delete(this.Guid).subscribe({
            next: (data) => {
              if(!environment.production) console.log("Data ",data);
              if(data.isSuccess == true){
                this.notifyService.MessageSuccessful("Borrado","Registro Borrado exitosamente");
                this.CancelButton();
                //refresca la capa de pines de geocercas para que el registro borrado deje de mostrarse en el mapa
                this.panelInternalLayerService.DeactivateLayer(this.panelInternalLayerService.geofenceLayer);
                this.panelInternalLayerService.ActivateLayer(this.panelInternalLayerService.geofenceLayer);
              }else{
                Sentry.captureMessage('PanelDetailGeofences.onDelete: eliminación sin éxito', { level: 'warning', extra: { response: data } });
                this.notifyService.MessageError("Problema al eliminar el registro");
              }
            },
            error: (error) => {
              // TODO marca para complete despues
              console.error('Error al eliminar geocerca', error);
              this.notifyService.MessageError("Problema al eliminar el registro");
            }
          });
        }
     });
    // this.panelAddGeofenceService.$guidEditable = this.Guid;
    // this.geofenceService.deleteGeofence(this.Guid);
  }

  CancelButton() {
    this.panelGeofenceDetailService.setVisibilityPopup(false);
    this.geofenceService.setVisiblePanelDetailGeofences(false);
    this.geofenceService.setVisiblePanelGeofences(true);
    if(!environment.production) console.log("cerrando popup");
  }

  toggleToolButton() {
    this.isToolButtonPressed = !this.isToolButtonPressed;
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }
}